import React from 'react';
import { MarketingPage } from '../components/marketing/MarketingPage';
import Image from 'next/image';

const Mission = () => (
  <div className="flex flex-col items-center justify-center px-6 mx-auto mt-16 max-w-4xl">
    <p className="text-5xl leading-tight text-black font-medium mb-12 text-center font-general-sans lg:text-4xl lg:leading-snug">
      Our mission is to help companies grow faster.
    </p>
    <p className="text-xl leading-relaxed text-black mb-16 text-center font-general-sans lg:text-lg lg:leading-normal">
      We are a team with deep passion and expertise in AI and security. We are building a platform to help companies build trust with their customers and partners. We are backed by world-class investors and advisors.
    </p>
  </div>
)

const Team = () => (
  <div className="flex justify-center w-full mb-16">
    <div className="flex flex-row flex-wrap justify-center gap-12 p-4">
      <TeamMember
        name="Naren Manoharan"
        position="Co-founder & CEO"
        image="/images/team/naren.png"
        linkedin="https://www.linkedin.com/in/narenmanoharan/"
      />
      <TeamMember
        name="Brett Thomas"
        position="Head of engineering"
        image="/images/team/brett.png"
        linkedin="https://www.linkedin.com/in/brett-thomas-a06/"
      />
      <TeamMember
        name="Khai Pham"
        position="Design consultant"
        image="/images/team/khai.png"
        linkedin="https://www.linkedin.com/in/khaip/"
      />
    </div>
  </div>
)

const TeamMember = ({ name, position, image, linkedin }) => (
  <div
    className="relative flex flex-col items-center justify-center cursor-pointer"
    onClick={() => window.open(linkedin)}
  >
    <Image
      src={image}
      alt={name}
      width={150}
      height={150}
    />
    <p className="mt-6 mb-2 text-xl font-medium text-black text-center font-general-sans">
      {name}
    </p>
    <p className="text-lg text-black text-center font-general-sans">
      {position}
    </p>
  </div>
)

const Investors = () => (
  <div className="flex flex-col items-center justify-center px-6 mx-auto max-w-4xl">
    <div className='flex flex-col items-center gap-10 mb-16'>
      <div className='font-general-sans text-2xl text-black font-medium mb-4'>Backed by leading investors</div>
      <div className="flex flex-wrap justify-center gap-10 md:gap-16">
        <div>
          <Image
            src="/images/logos/investors/ycombinator.svg"
            alt="YCombinator"
            height={36}
            width={162}
          />
        </div>
        <div>
          <Image
            src="/images/logos/investors/khosla.svg"
            alt="Khosla ventures"
            height={90}
            width={180}
          />
        </div>
        <div>
          <Image
            src="/images/logos/investors/twenty_two.svg"
            alt="Twenty Two ventures"
            height={36}
            width={150}
          />
        </div>
        <div>
          <Image
            src="/images/logos/investors/page_one.svg"
            alt="Page One VC"
            height={54}
            width={86}
          />
        </div>
      </div>
    </div>
  </div>
)

export default function AboutPage() {
  return (
    <MarketingPage>
      <Mission />
      <Team />
      <Investors />
    </MarketingPage>
  );
}